module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"sv":{"mec_input:error_required_field":"Obligatoriskt fält","mec_input:error_invalid_format":"Ogiltigt format"},"en":{"mec_input:error_required_field":"Required field","mec_input:error_invalid_format":"Invalid format"}}')
  delete Component.options._Ctor
}
